import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiButton } from '@taiga-ui/core';
import { TuiPagination, TuiCarousel, TuiAvatar } from '@taiga-ui/kit';
import { TestingModule } from '@src/app/modules/testing';
import { ComponentsModule } from '@src/app/components';

import { SharedModule } from '../shared.module';

import { DialogConfirmComponent } from './dialog-confirm/dialog-confirm.component';
import { DialogImageViewingComponent } from './dialog-image-viewing/dialog-image-viewing.component';
import { UpdateAppDialogComponent } from './update-app-dialog/update-app-dialog.component';
import { OfflineDialogComponent } from './offline-dialog/offline-dialog.component';
import { DialogConfirmCommonComponent } from './dialog-confirm-common/dialog-confirm-common.component';
import { ManyTabsDialogComponent } from './many-tabs-dialog/many-tabs-dialog.component';
import { WelcomeDialogsComponent } from './welcome-dialogs';

@NgModule({
  declarations: [
    DialogConfirmComponent,
    DialogImageViewingComponent,
    UpdateAppDialogComponent,
    OfflineDialogComponent,
    DialogConfirmCommonComponent,
    ManyTabsDialogComponent,
    WelcomeDialogsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TuiButton,
    ...TuiCarousel,
    TuiPagination,
    TuiAvatar,
    TestingModule,
    ComponentsModule,
  ],
  exports: [
    DialogConfirmComponent,
    DialogConfirmCommonComponent,
    DialogImageViewingComponent,
    UpdateAppDialogComponent,
    OfflineDialogComponent,
    ManyTabsDialogComponent,
  ],
})
export class DialogsModule {}
